export type CategoryDTO = {
	code: string;
	name: string;
}

export function getCategories() {
	return [
		{
			code: "101",
			name: "Empregado - Geral, inclusive o empregado público da administração direta ou indireta contratado pela CLT."
		},
		{
			code: "102",
			name: "Empregado - Trabalhador Rural por Pequeno Prazo da Lei 11.718/2008"
		},
		{
			code: "103",
			name: "Empregado - Aprendiz"
		},
		{
			code: "104",
			name: "Empregado - Doméstico"
		},
		{
			code: "105",
			name: "Empregado - contrato a termo firmado nos termos da Lei 9601/98"
		},
		{
			code: "106",
			name: "Trabalhador Temporário - contrato nos termos da Lei 6.019/74"
		},
		{
			code: "107",
			name: "Empregado - Contrato de trabalho Verde e Amarelo - sem acordo para antecipação mensal da multa rescisória do FGTS"
		},
		{
			code: "108",
			name: "Empregado - Contrato de trabalho Verde e Amarelo - com acordo para antecipação mensal da multa rescisória do FGTS"
		},
		{
			code: "111",
			name: "Empregado - contrato de trabalho intermitente "
		},
		{
			code: "201",
			name: "Trabalhador Avulso Portuário"
		},
		{
			code: "202",
			name: "Trabalhador Avulso Não Portuário"
		},
		{
			code: "301",
			name: "Servidor Público Titular de Cargo Efetivo, Magistrado, Ministro de Tribunal de Contas, Conselheiro de Tribunal de Contas..."
		},
		{
			code: "302",
			name: "Servidor Público Ocupante de Cargo exclusivo em comissão"
		},
		{
			code: "303",
			name: "Exercente de mandato eletivo"
		},
		{
			code: "304",
			name: "Servidor público exercente de mandato eletivo, inclusive com exercício de cargo em comissão"
		},
		{
			code: "305",
			name: "Servidor Público indicado para conselho ou órgão deliberativo, na condição de representante do governo, órgão..."
		},
		{
			code: "306",
			name: "Servidor público contratado por tempo determinado, sujeito a regime administrativo especial definido em lei própria"
		},
		{
			code: "307",
			name: "Militar dos Estados e Distrito Federal"
		},
		{
			code: "308",
			name: "Conscrito"
		},
		{
			code: "309",
			name: "Agente Público - Outros"
		},
		{
			code: "310",
			name: "Servidor público eventual"
		},
		{
			code: "311",
			name: "Ministros, juízes, procuradores, promotores ou oficiais de justiça à disposição da Justiça Eleitoral"
		},
		{
			code: "312",
			name: "Auxiliar local"
		},
		{
			code: "313",
			name: "Servidor público exercente de atividade de instrutoria, capacitação, treinamento, curso ou concurso..."
		},
		{
			code: "401",
			name: "Dirigente Sindical - informação prestada pelo Sindicato"
		},
		{
			code: "410",
			name: "Trabalhador cedido/exercício em outro órgão/juiz auxiliar - Informação prestada pelo cessionário/destino"
		},
		{
			code: "501",
			name: "Dirigente sindical - Segurado especial"
		},
		{
			code: "701",
			name: "Contribuinte individual - Autônomo em geral, exceto se enquadrado em uma das demais categorias de contribuinte individual"
		},
		{
			code: "711",
			name: "Contribuinte individual - Transportador autônomo de passageiros"
		},
		{
			code: "712",
			name: "Contribuinte individual - Transportador autônomo de carga"
		},
		{
			code: "721",
			name: "Contribuinte individual - Diretor não empregado, com FGTS"
		},
		{
			code: "722",
			name: "Contribuinte individual - Diretor não empregado, sem FGTS"
		},
		{
			code: "723",
			name: "Contribuinte individual - empresários, sócios e membro de conselho de administração ou fiscal"
		},
		{
			code: "731",
			name: "Contribuinte individual - Cooperado que presta serviços por intermédio de Cooperativa de Trabalho"
		},
		{
			code: "734",
			name: "Contribuinte individual - Transportador Cooperado que presta serviços por intermédio de cooperativa de trabalho"
		},
		{
			code: "738",
			name: "Contribuinte individual - Cooperado filiado a Cooperativa de Produção"
		},
		{
			code: "741",
			name: "Contribuinte individual - Microempreendedor Individual"
		},
		{
			code: "751",
			name: "Contribuinte individual - magistrado classista temporário da Justiça do Trabalho ou da Justiça Eleitoral que seja aposentado..."
		},
		{
			code: "761",
			name: "Contribuinte individual - Associado eleito para direção de cooperativa, associação ou entidade de classe..."
		},
		{
			code: "771",
			name: "Contribuinte individual - Membro de conselho tutelar, nos termos da Lei no 8.069, de 13 de julho de 1990"
		},
		{
			code: "781",
			name: "Ministro de confissão religiosa ou membro de vida consagrada, de congregação ou de ordem religiosa "
		},
		{
			code: "901",
			name: "Estagiário"
		},
		{
			code: "902",
			name: "Médico residente ou residente em área profissional de saúde"
		},
		{
			code: "903",
			name: "Bolsista"
		},
		{
			code: "904",
			name: "Participante de curso de formação, como etapa de concurso público, sem vínculo de emprego/estatutário"
		}
	] as CategoryDTO[];
}